export default {
  props: {
    id: {
      type: String
    },
    customClassName: {
      type: String
    }
  }
};
